import { render, staticRenderFns } from "./BlogMain.vue?vue&type=template&id=c56d6878"
import script from "./BlogMain.vue?vue&type=script&lang=js"
export * from "./BlogMain.vue?vue&type=script&lang=js"
import style0 from "./BlogMain.vue?vue&type=style&index=0&id=c56d6878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports